<template>
  <div class="charts-2col-eq">
    <div class="nps-card">
      <div class="nps-card-title">{{ topTitle }}</div>
      <div v-for="item in normalizedTop" :key="`top-${item.name}`" class="bar-row">
        <div class="bar-label">{{ item.name }}</div>
        <div class="bar-track">
          <div class="bar-fill" :style="{ width: `${item.width}%` }"></div>
        </div>
        <div class="bar-value">{{ item.responses }}</div>
      </div>
    </div>
    <div class="nps-card">
      <div class="nps-card-title">{{ bottomTitle }}</div>
      <div v-for="item in normalizedBottom" :key="`bottom-${item.name}`" class="bar-row">
        <div class="bar-label">{{ item.name }}</div>
        <div class="bar-track">
          <div class="bar-fill bottom" :style="{ width: `${item.width}%` }"></div>
        </div>
        <div class="bar-value">{{ item.responses }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaRankingVolumeSection',
  props: {
    topItems: {
      type: Array,
      default: function () {
        return [];
      }
    },
    bottomItems: {
      type: Array,
      default: function () {
        return [];
      }
    },
    topTitle: {
      type: String,
      default: '🏆 TOP 10 - Mayor volumen'
    },
    bottomTitle: {
      type: String,
      default: '⬇ BOTTOM 10 - Menor volumen'
    }
  },
  computed: {
    normalizedTop () {
      return this.normalizeItems(this.topItems);
    },
    normalizedBottom () {
      return this.normalizeItems(this.bottomItems);
    }
  },
  methods: {
    normalizeItems (items) {
      let max = 0;
      items.forEach(function (item) {
        if (item.responses > max) {
          max = item.responses;
        }
      });

      return items.map(function (item) {
        return Object.assign({}, item, {
          width: max > 0 ? Math.max((item.responses / max) * 100, 8) : 0
        });
      });
    }
  }
};
</script>

<style scoped>
.charts-2col-eq {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
}

.nps-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  min-height: 320px;
  padding: 20px 22px;
}

.nps-card-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}

.bar-row {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}

.bar-label {
  color: var(--text-primary, #1A1A2E);
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 140px;
}

.bar-track {
  background: #EEF0F5;
  border-radius: 4px;
  flex: 1;
  height: 16px;
  overflow: hidden;
}

.bar-fill {
  background: #E94560;
  border-radius: 4px;
  height: 100%;
  transition: width 0.4s ease;
}

.bar-value {
  color: var(--text-primary, #1A1A2E);
  font-size: 12px;
  font-weight: 700;
  width: 45px;
}

.bar-fill.bottom {
  background: #6366F1;
}

@media (max-width: 900px) {
  .charts-2col-eq {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/RankingVolumeSection.vue